import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";

// Define a type for the slice state
export type FaderState = {
  fading: boolean;
};

// Define the initial state using that type
const initialState: FaderState = {
  fading: true,
};

export const FaderSlice = createSlice({
  name: "fader",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setFader: (_fader: FaderState, action: PayloadAction<FaderState>) => {
      return { ...action.payload };
    },
  },
});

export const { setFader } = FaderSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectStatus = (state: RootState) => state;

export default FaderSlice.reducer;
